import { PriceBoostConfig } from '@frontend/sports/common/client-config-data-access';

import { OptionContextService } from './option-context.service';

export const optionContextServiceProviderFactory = (isPriceBoostContext: boolean) => ({
    provide: OptionContextService,
    useFactory: (priceBoostConfig: PriceBoostConfig) => new OptionContextService(priceBoostConfig, isPriceBoostContext),
    deps: [PriceBoostConfig],
});
